// Utility functions for AntDesign Tree component

import type { DataNode, TreeProps } from 'antd/lib/tree';

/**
 * This function can be used to write the `onDrop` handler for the AntDesign Tree component.
 * This only works for a tree that is linear, i.e. no nested nodes.
 * Returns the key and new position of the updated node.
 */
export const doLinearDragAndDrop = (
  treeData: DataNode[],
  info: Parameters<Exclude<TreeProps['onDrop'], undefined>>[0],
) => {
  const dropKey = info.node.key;
  const dragKey = info.dragNode.key;
  const dropPos = info.node.pos.split('-');
  const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]); // the drop position relative to the drop node, inside 0, top -1, bottom 1

  const dragIndex = treeData.findIndex((node) => node.key === dragKey);
  const dropIndex = treeData.findIndex((node) => node.key === dropKey);
  let newPosition = dropIndex + (dropPosition === -1 ? 0 : 1);

  if (newPosition > dragIndex) {
    newPosition -= 1; // Adjust if the drag node is before the drop node
  }

  return { dragKey, newPosition };
};
